import { Button } from '@mui/material';
import { TemplateType, TemplateTypeLabel } from '../../../common/EmailDetails';

interface MarinerSimpleEmailTemplateProps {
  template: TemplateType,
  handleTemplateChange: (templateType: TemplateType) => void,
}

const TEMPLATE_NAME_LIST: TemplateType[] = [
  TemplateType.PRE_ARRIVAL,
  TemplateType.JOINING_INSTRUCTIONS,
];

const MarinerSimpleEmailTemplate = (props: MarinerSimpleEmailTemplateProps) => (
  <>
    {TEMPLATE_NAME_LIST.map((templateName: TemplateType) => (
      <Button
        key={templateName}
        variant="outlined"
        className={
          props.template === templateName
            ? "blue-button"
            : "grey-button"
        }
        onClick={() => props.handleTemplateChange(templateName)}
      >
        {TemplateTypeLabel[templateName as TemplateType]}
      </Button>
    ))}
 </>
);

export default MarinerSimpleEmailTemplate;
